module.exports = __webpack_public_path__ + "img/person.94e37df9.png";